import { TokenName } from "./colors";

// camelCase token name -> kebab-case CSS variable name (without the leading --).
// grey10 -> grey-10, surfaceMinus1 -> surface-minus-1, onPrimary -> on-primary, bw -> bw.
export const toCssVarName = (token: TokenName): string =>
  token
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/([a-zA-Z])(\d)/g, "$1-$2")
    .replace(/(\d)([a-zA-Z])/g, "$1-$2")
    .toLowerCase();
